export default __webpack_public_path__ + "static/media/mirakl-logo.27393188.png";